<app-splash-screen *ngIf="!maintenance"></app-splash-screen>
<router-outlet></router-outlet>
